const initMap = function (mapContainer, initialMapOptions) {
    return new window.google.maps.Map(mapContainer.value, initialMapOptions.value);
}

export default initMap